import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   .flex {
      display: flex;
      align-items: center;
      margin-bottom: 7.5px;
   }
   .status {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: rgb(245, 245, 245);
      border: 1px solid rgb(220, 220, 220);
      border-radius: 10px;
      padding: 7.5px 15px;
      font-size: 15px;
      min-height: 35px;

      &.memory {
         width: 100%;
         margin-right: 7.5px;
      }
      &.remove {
         color: #E02424;
         width: 45px;
         min-width: 45px;
         transition: all .2s ease-in-out;
         cursor: pointer;

         &:hover {
            background-color: #E02424;
            color: #fff;
         }
      }
      > div {
         display: flex;
         justify-content: center;
         align-items: center;
         width: 150px;
         margin-bottom: 3px;

         &:not(:last-of-type) {
            margin-bottom: 7.5px;
         }
         span:first-of-type {
            width: 10px;
            height: 10px;
            background-color: #339966;
            margin-right: 7.5px;
            border-radius: 2px;
            box-shadow: 0 0 3px #339966;
         }
         span:last-of-type {
            opacity: 0.85;
         }
      }
      .empty {
         opacity: 0.8;
         text-align: center;
      }
   }
   .unique {
      margin-top: 15px;
      margin-bottom: 5px;
   }
   .auto {
      margin-top: 12px;
      margin-bottom: 5px;
   }
   .force {
      margin-top: 12px;
   }
`;